'use client';

import * as React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import {
  BoxIcon,
  ChevronRightIcon,
  CircuitBoardIcon,
  FileBarChartIcon,
  LayoutIcon,
  PlayIcon
} from 'lucide-react';
import { motion } from 'motion/react';

import { routes } from '@workspace/routes';
import { Badge } from '@workspace/ui/components/badge';
import { buttonVariants } from '@workspace/ui/components/button';
import { ScrollArea, ScrollBar } from '@workspace/ui/components/scroll-area';
import { Separator } from '@workspace/ui/components/separator';
import {
  UnderlinedTabs,
  UnderlinedTabsContent,
  UnderlinedTabsList,
  UnderlinedTabsTrigger
} from '@workspace/ui/components/tabs';
import { cn } from '@workspace/ui/lib/utils';

import { GridSection } from '~/components/fragments/grid-section';
import { SavingsCard } from '../cards';

export function Wizard(): React.JSX.Element {
  return (
    <GridSection className="overflow-x-hidden">
      <SavingsCard
        onSelect={(amount) => console.log('Selected:', amount)}
        step="1/6"
      />
    </GridSection>
  );
}
